interface GetCuttedString {
  text: string;
  maxNumberOfWords: number;
  separator?: string;
}

// eslint-disable-next-line import/prefer-default-export
export const getCuttedString = ({ text, maxNumberOfWords, separator = ' ' }: GetCuttedString) =>
  text.split(separator).slice(0, maxNumberOfWords).join(separator);
